import createReactComponent from '../createReactComponent';
export default createReactComponent('number-10-small', 'IconNumber10Small', [
  ['path', { d: 'M7 10l2 -2v8', key: 'svg-0' }],
  ['path', { d: 'M13 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z', key: 'svg-1' }],
]);
